module.exports = __webpack_public_path__ + "static/media/features-split-image-02.2b3589a5.png";